<script>
    import { writable } from 'svelte/store'
    import Typography from '$lib/components/UI/Typography.svelte'
    import CaretDown from '$lib/components/Icons/CaretDown.svelte'
    import CaretUp from '$lib/components/Icons/CaretUp.svelte'
    export let sortDirective = writable([])
    async function toggleSortDirective(key) {
        let pos = $sortDirective.findIndex((x) => x === key || x === `-${key}`)
        let col = pos !== -1 ? $sortDirective[pos] : null
        let negate = col ? col[0] === '-' : null
        console.log(pos, col, negate)
        if (col !== null) {
            if (negate) {
                // $sortDirective = $sortDirective.filter(x => x !== key || x !== `-${key}`);
                $sortDirective = []
            } else {
                $sortDirective[pos] = `-${key}`
            }
        } else {
            await sortDirective.update((all) => [...all, key])
        }
        console.log('sortDirective: ', $sortDirective)
    }
</script>

<tr>
    <td
        on:click={(_) => {
            toggleSortDirective('ref')
        }}
    >
        <span>
            <Typography type="caption" color="grey-800">
                No. de factura
            </Typography>
            <svelte:component
                this={$sortDirective.includes('ref') ||
                $sortDirective.includes('-ref')
                    ? $sortDirective.includes('ref')
                        ? CaretDown
                        : CaretUp
                    : null}
                size={16}
            />
        </span>
    </td>
    <td
        on:click={(_) => {
            toggleSortDirective('fecha_creacion')
        }}
    >
        <span>
            <Typography type="caption" color="grey-800">
                Fecha de ingreso
            </Typography>
            <svelte:component
                this={$sortDirective.includes('fecha_creacion') ||
                $sortDirective.includes('-fecha_creacion')
                    ? $sortDirective.includes('fecha_creacion')
                        ? CaretDown
                        : CaretUp
                    : null}
                size={16}
            />
        </span>
    </td>
    <td
        on:click={(_) => {
            toggleSortDirective('importe_total')
        }}
    >
        <span>
            <Typography type="caption" color="grey-800">
                Importe total
            </Typography>
            <svelte:component
                this={$sortDirective.includes('importe_total') ||
                $sortDirective.includes('-importe_total')
                    ? $sortDirective.includes('importe_total')
                        ? CaretDown
                        : CaretUp
                    : null}
                size={16}
            />
        </span>
    </td>
    <td
        on:click={(_) => {
            toggleSortDirective('estado')
        }}
    >
        <span>
            <Typography type="caption" color="grey-800">Estado</Typography>
            <svelte:component
                this={$sortDirective.includes('estado') ||
                $sortDirective.includes('-estado')
                    ? $sortDirective.includes('estado')
                        ? CaretDown
                        : CaretUp
                    : null}
                size={16}
            />
        </span>
    </td>
    <td><Typography type="caption" color="grey-800" /></td>
</tr>

<style>
    span {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;
    }
</style>
